import React from 'react';
import I18n from 'i18n-js';
import peekItemImg from 'public/images/peek-item.svg';
import styles from './order-item-onboarding.less';

const localeKeyPrefix = 'shopify.orders.onboarding';

const OrderItemOnboarding = () => (
  <div className={styles.OrderItemOnboarding}>
    <img className={styles.image} src={peekItemImg} alt={'PeekItemImage'} />
    <div className={styles.title}>
      {I18n.t(`${localeKeyPrefix}.itemDetail.title`)}
    </div>
    <div className={styles.message}>
      {I18n.t(`${localeKeyPrefix}.itemDetail.message`)}
    </div>
  </div>
);

// location listener
// remove white area

export default OrderItemOnboarding;
